<template>
  <div v-if="isDisplay" class="important-news-area">
    <ul class="news-list">
      <li v-for="(newsItem) in importantNews" :key="newsItem.id" class="news-item">
        <router-link :to="{ name: 'News', params: { id: newsItem.id } }">
          {{ newsItem.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { GetNews } from '@/features/News/axios';
import { NewsItem, NewsListResponse } from "@/features/News/types/response";
import { notifyErrorMessage } from "@/plugins/notification";
import { useStore } from 'vuex';
import { computed } from 'vue';
import type { AxiosResponse } from "axios";

type PageNameType = 'Dashboard' | 'ChainAnalyticsVisitor';

const dayOfWeeks = ['月', '火', '水', '木', '金', '土', '日'];

const props = defineProps<{
  pageName: PageNameType;
}>();

const store = useStore();
const isYoku = computed<boolean>(() => store.getters.isYoku).value;

const isTargetPage = (()=>{
  // よくみえーる契約を含む場合、ダッシュボードに重要なお知らせを表示する
  if (isYoku && props.pageName === "Dashboard") {
    return true;
  }
  // ひろくみえーる契約のみの場合、チェーン分析に重要なお知らせを表示する
  if (!isYoku && props.pageName === "ChainAnalyticsVisitor") {
    return true;
  }
  // それ以外は表示しない
  return false;
})();


const importantNews = await (async () => {
  // 重要なお知らせを表示すべき画面でない場合、取得処理を行わない
  if (!isTargetPage) {
    return [];
  }

  return await GetNews()
  .then((res: AxiosResponse<NewsListResponse>) => {
    return res.data.news
      .filter((newsItem: NewsItem) => newsItem.is_important === true)
      .sort(
        (prev, next) =>
          new Date(next.published_at).getTime() -
          new Date(prev.published_at).getTime()
      );
  })
  .catch(() => notifyErrorMessage("重要なお知らせの取得に失敗しました。"));
})();

const isDisplay = isTargetPage && importantNews && importantNews.length > 0;

</script>

<style scoped lang="scss">
.important-news-area {
  margin: 20px 0;
}

.news-list {
  list-style: none;
  text-align: left;
}

.news-item {
  & + & {
    margin-top: 10px;
  };
  a {
    color: #222222;
    font-size: 14px;
  };
  padding: 10px 16px;
  border-radius: 6px;
  color: #222222;
  background-color: #F8E2E2;
}

</style>
